import { useEffect } from 'react';
import banner from '../../assets/images/banner.jpg';

export default function Header() {
    useEffect(() => {
        // Create the script element
        const script = document.createElement('script');
        script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','GTM-WHWCQ2C7');`;

        // Append the script to the head or body
        document.head.appendChild(script);

        // Clean up the script when the component unmounts
        return () => {
            document.head.removeChild(script);
        };
    }, []); // Empty dependency array ensures this runs only once after the component mounts

    return (
        <header className="header-container" style={{ backgroundImage: `url(${banner})` }}>
            <h1 data-aos={'fade-down'}>Mental Health Clinic</h1>
            <p data-aos={'fade-up'}>Welcome to Your Journey Counseling and Wellness where we believe that YOUR journey is personal and to be respected. Let us help you reach your destination one step at a time.</p>
            <h4 data-aos="zoom-in">Schedule Your First Appointment:</h4>
            <div className="header-buttons" data-aos="zoom-in">
                <a href="#Therapists" className='btn-appointment'>Find Therapists</a>
                <a href="#Therapists" className='btn-appointment'>Book Appointment</a>
            </div>
        </header>
    );
}
